import { useState } from "react";
import { toast } from "sonner";
import { CalendarPlus } from "lucide-react";
import { api, catLabel, errMsg, fmtDate } from "@/lib/api";
import { useFetch } from "@/hooks/useFetch";
import { inputCls } from "@/components/landing/ProposalForm";

const LEAD_STATUS = [["novo", "Novo"], ["em_contato", "Em contato"], ["fechado", "Fechado"], ["recusado", "Recusado"]];

const ToEvent = ({ lead, team, done }) => {
  const [pid, setPid] = useState("");
  const create = async () => {
    try {
      await api.post(`/panel/leads/${lead.id}/create-event`, { photographer_id: pid });
      toast.success("Evento criado e publicado. Envie as fotos em Eventos & fotos.");
      done();
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  return (
    <div className="mt-4 flex flex-wrap items-center gap-2">
      <select value={pid} onChange={(e) => setPid(e.target.value)} className={`${inputCls} !w-auto !py-2 text-sm`} data-testid={`lead-photographer-select-${lead.id}`}>
        <option value="" className="bg-ink">Escolher fotógrafo…</option>
        {team.map((u) => <option key={u.id} value={u.id} className="bg-ink">{u.name}</option>)}
      </select>
      <button disabled={!pid} onClick={create} className="inline-flex items-center gap-1.5 rounded-full bg-flash px-4 py-2 text-sm font-semibold text-ink disabled:opacity-50" data-testid={`lead-create-event-${lead.id}`}>
        <CalendarPlus className="h-4 w-4" /> Aprovar e criar evento
      </button>
    </div>
  );
};

export const PanelLeads = ({ user }) => {
  const { data, reload } = useFetch("/panel/leads", []);
  const { data: team } = useFetch(user.role === "admin" ? "/panel/photographers" : null, []);
  const leads = Array.isArray(data) ? data : [];

  const setStatus = async (id, status) => {
    await api.patch(`/panel/leads/${id}`, { status }).catch((e) => toast.error(errMsg(e)));
    reload();
  };

  return (
    <div className="grid gap-3" data-testid="panel-leads">
      {leads.map((l) => {
        const d = l.data || {};
        const isReq = l.kind === "event_request";
        return (
          <div key={l.id} className="rounded-2xl border border-white/10 bg-ink-2 p-5" data-testid={`lead-row-${l.id}`}>
            <div className="flex flex-wrap items-start justify-between gap-3">
              <div>
                <span className={`rounded-full px-2.5 py-0.5 font-mono text-[11px] uppercase ${isReq ? "bg-violet/25 text-violet-lilac" : "bg-flash/15 text-flash"}`}>{isReq ? "Proposta de evento" : "Orçamento"}</span>
                <p className="mt-2 font-semibold">{isReq ? d.event_name : d.event_type} {d.date && <span className="text-haze">· {fmtDate(d.date)}</span>}</p>
                <p className="text-sm text-haze">{l.name}{d.company && ` (${d.company})`} · {l.email} · {l.phone}</p>
                <p className="mt-1 text-sm text-foreground/85">
                  {isReq && <>{catLabel(d.category)} · {d.location} · público {d.expected_people || "—"} · <b className="text-flash">R$ {Number(d.price_per_photo || 0).toFixed(2)}/foto</b></>}
                  {!isReq && <>{d.location} {d.guests && `· ${d.guests} convidados`}</>}
                </p>
                {d.message && <p className="mt-2 max-w-2xl text-sm text-haze">"{d.message}"</p>}
              </div>
              <select value={l.status} onChange={(e) => setStatus(l.id, e.target.value)} className={`${inputCls} !w-auto !py-2 text-sm`} data-testid={`lead-status-${l.id}`}>
                {LEAD_STATUS.map(([k, t]) => <option key={k} value={k} className="bg-ink">{t}</option>)}
              </select>
            </div>
            {isReq && user.role === "admin" && !l.event_id && <ToEvent lead={l} team={Array.isArray(team) ? team : []} done={reload} />}
          </div>
        );
      })}
      {!leads.length && <p className="text-haze" data-testid="panel-leads-empty">Nenhuma solicitação ainda.</p>}
    </div>
  );
};
